import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import { Link, useRouter } from '@sls-react/routing';
import { useModals } from '@sls-react/contexts/ModalsContext';
import qsStringify from '@sls-react/utils/qsStringify';

interface LoginLinkOptions {
  destination?: string;
  message?: string;

  /**
   * Applied to the "destination" param on the login page as a query string
   * Can be used to define "return actions," like once logged in, come back and do this.
   */
  returnParams?: Record<string, any>;
  skipOnboarding?: boolean;
  onSuccessfulLogin?: () => void;
}

type Props = AnchorProps & LoginLinkOptions;

export function generateLoginLink(options?: LoginLinkOptions) {
  return `/login${qsStringify(options)}`;
}

const LoginLink: React.FC<Props> = ({
  children,
  destination,
  message,
  onSuccessfulLogin,
  returnParams,
  skipOnboarding,
  ...props
}) => {
  const router = useRouter();
  const modals = useModals();

  if (router.route === '/login' || router.route === '/register') {
    return (
      <Link href="/login">
        <a
          rel="nofollow noindex"
          aria-label="Sign into your SidelineSwap Account"
          {...props}
        >
          {children}
        </a>
      </Link>
    );
  }

  return (
    <button
      className={props.className}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        modals.openModal('loginRegister', {
          onSuccessfulLogin,
          contextMessage: message,
          defaultView: 'login',
          skipOnboarding,
        });
      }}
      aria-label="Sign into your SidelineSwap Account"
    >
      {children}
    </button>
  );
};

export default LoginLink;
